module.exports = __webpack_public_path__ + "img/6.36933227.jpg";